'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var resolveTitleSize = function (size) { return (size === 'LARGE' ? '36px/36px' : '24px/24px'); };
var resolveTitleSpacing = function (spacing) { return (spacing ? spacing + "px" : '8px'); };
var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"])));
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 500 ", " ", ";\n  color: ", ";\n"], ["\n  font: 500 ", " ", ";\n  color: ", ";\n"])), function (props) { return resolveTitleSize(props.size); }, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Subtitle = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/14px ", ";\n  margin-top: ", ";\n  color: ", ";\n"], ["\n  font: 400 14px/14px ", ";\n  margin-top: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (props) { return resolveTitleSpacing(props.spacing); }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var templateObject_1, templateObject_2, templateObject_3;

exports.Container = Container;
exports.Subtitle = Subtitle;
exports.Title = Title;
